export default {
  GET_TOKEN_BALANCE: 'GET_TOKEN_BALANCE',
} as const;
